import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button } from '@material-ui/core/'
import StoryModal from '../StoryModal'
import apiAdmin from '../../../../../../../api/admin'
import filterIcon from '../../../../../../../assetss/img/filterIcon.svg'
import avatarIcon from '../../../../../../../assetss/img/avatarIcon.svg'
import likeIcon from '../../../../../../../assetss/img/likeIcon.svg'
import './index.scss'

const Stories = () => {
  const { user } = useSelector(({ session }) => session)
  const [storysList, setStorysList] = useState([])
  const [idStory, setIdStory] = useState('')
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [countStory, setCountStory] = useState(0)
  const [skip, setSkip] = useState(0)

  const getFullStory = () => {
    apiAdmin?.getFullStory(user?.accessKey, skip)
      .then(({ data }) => {
        setStorysList(data?.stories)
      })
  }

  const getFullStorySkip = () => {
    apiAdmin?.getFullStory(user?.accessKey, skip + 20)
      .then(({ data }) => {
        setStorysList(prev => [...prev, ...data?.stories])
        setSkip(prev => prev + 20)
      })
      .finally(() => setLoading(false))
  }

  const getStoryCount = () => {
    apiAdmin?.getStoryCount()
      .then(({ data }) => {
        setCountStory(data?.count)
      })
  }

  const onDelete = () => {
    apiAdmin.deleteStory(idStory, user?.accessKey)
      .then(() => {
        getFullStory()
        setIdStory('')
      })
      .finally(() => setOpen(false))
  }

  const scrollHandler = e => {
    if (e.target.scrollHeight - (e.target.scrollTop + window.innerHeight) < 40) {
      setLoading(true)
    }
  }

  useEffect(() => {
    window?.addEventListener('scroll', scrollHandler, true)
    return function () {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  }, [])

  useEffect(() => {
    getFullStory()
    getStoryCount()
  }, [])

  useEffect(() => {
    if (loading && +storysList?.length < countStory) {
      getFullStorySkip()
    }
  }, [loading])

  return (
    <Grid className='tableUsersStorys'>
      <StoryModal open={open} setOpen={setOpen} onDelete={onDelete} setIdStory={setIdStory} />
      <Grid className='tableHeaderStorys'>
        <Grid className='headerName'>
          Story <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerEmail'>
          Email <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerMeetings'>
          Name <img src={filterIcon} className='iconFilter' />
        </Grid>
        <Grid className='headerLikeStorys'>
          <img src={likeIcon} />
        </Grid>
        <Grid className='headerCity'>
          <span className='cityActions'>City <img src={filterIcon} className='iconFilter' /></span>
          <span className='actionsStorys'>Action</span>
        </Grid>
      </Grid>
      {storysList?.map(({ email, name, storiesCount, town, likesCount, meetingsCount, uuid, stories, title, author }) => (
        <Grid className='tableBodyStorys' key={email}>
          <Grid className='bodyName'>
            <img src={avatarIcon} className='iconAvatar' /> {title}
          </Grid>
          <Grid className='bodyEmail'>
            {author?.email}
          </Grid>
          <Grid className='bodyMeetingsStorys'>
            {author?.name}
          </Grid>
          <Grid className='bodyLikeStorys'>
            {likesCount}
          </Grid>
          <Grid className='bodyCity'>
            <Grid>{author?.town}</Grid>
            <Button
              onClick={() => {
                setIdStory(uuid)
                setOpen(true)
              }}
              className='btnCansel'
              variant='contained'
            >
              DELETE
            </Button>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Stories
